import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-page-5',
    templateUrl: './custom-page-5.component.html',
    styleUrls: ['./custom-page-5.component.scss'],
})
export class CustomPage5Component implements OnInit {

    constructor(
    ) {

    }


    ngOnInit(): void {
    }
}